import { DAY_OF_WEEK } from "@/const/Constants";
import OptionConst from "@/const/Option";
import { KoyouKeiyakuTime } from "@/types/KoyouKeiyaku";
import { HayabanOsoban } from "@/types/Shinsei";
import { reactive } from "vue";

export function useInit() {
  const hayabanOsoban: HayabanOsoban = reactive({
    koyou_keiyaku_id: null,
    mst_syuugyou_basyo_id: null,
    user_id: null,
    shinsei_date: null,
    target_dakoku_date: null,
    start_datetime: null,
    end_datetime: null,
    kyuukei_times:null,
    notes: null,
    hayaban_osoban_id: null,
    isClosed: false
  });

  const getWorkTime = (targetDate: string | Date, workTimes: KoyouKeiyakuTime[] | null) => {
    if(!workTimes){
      return false
    }
    
    // 選択した勤務日から曜日を取得
    let date = new Date(targetDate)
    const youbiNum = date.getDay()

    // 取得した曜日を比較して曜日タイプを取得
    const data = workTimes.find(v => {
      const youbi = DAY_OF_WEEK[youbiNum]
      switch (youbi) {
        case OptionConst.YOUBI_LABEL.MONDAY:
          return v.is_monday;
        case OptionConst.YOUBI_LABEL.TUESDAY:
          return v.is_tuesday;
        case OptionConst.YOUBI_LABEL.WEDNESDAY:
          return v.is_wednesday;
        case OptionConst.YOUBI_LABEL.THURSDAY:
          return v.is_thursday;
        case OptionConst.YOUBI_LABEL.FRIDAY:
          return v.is_friday;
        case OptionConst.YOUBI_LABEL.SATURDAY:
          return v.is_saturday;
        case OptionConst.YOUBI_LABEL.SUNDAY:
          return v.is_sunday;
      }
    })

    // 該当の曜日があれば勤務時間の開始・終了をセット
    if(data){
      hayabanOsoban.start_datetime = data.start_time
      hayabanOsoban.end_datetime = data.end_time
      return true
    }else{
      // 無ければメッセージ出してボタンを押せないようにする？
      hayabanOsoban.start_datetime = null
      hayabanOsoban.end_datetime = null
      return false
    }
  }

  return {
    hayabanOsoban,
    getWorkTime
  }
}
